// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"504ccc44","172":"6762bd89","487":"edc11756","567":"d9dbc291","622":"8806e132","788":"14ed35f5"}[chunkId] + ".chunk.js";
};